import { useState, useEffect, useRef } from 'react';

function getStableHeight() {
  return Math.max(window.innerHeight, window.visualViewport?.height ?? 0);
}

export default function useWindowDimensions() {
  const lockedHeightRef = useRef<number | null>(null);
  const [size, setSize] = useState(() => ({
    width: window.innerWidth,
    height: getStableHeight(),
  }));

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width <= 768) {
        if (lockedHeightRef.current == null) {
          lockedHeightRef.current = getStableHeight();
        }
        setSize({ width, height: lockedHeightRef.current });
      } else {
        // desktop: real resize
        setSize({ width, height: window.innerHeight });
      }
    };

    window.addEventListener('resize', handleResize);
    window.visualViewport?.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.visualViewport?.removeEventListener('resize', handleResize);
    };
  }, []);

  return size;
}
